function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'svart': 'rgb(0, 0, 0)','rod': 'rgb(246, 31, 31)','cream': 'rgb(255, 253, 208)','morkgron': 'rgb(29, 93, 88)','turkos': 'rgb(0, 255, 255)','candy-pink': 'rgb(255, 97, 125)','taupe': 'rgb(201, 176, 156)','morkbla': 'rgb(32, 69, 105)','peach': 'rgb(235, 153, 130)','mousse': 'rgb(180, 143, 126)','charcoal': 'rgb(68, 69, 73)','cappuccino': 'rgb(208, 172, 128)','clay': 'rgb(234, 110, 86)','gammelrosa': 'rgb(192, 128, 129)','sea-forest': 'rgb(12, 88, 100)','lila': 'rgb(200, 162, 200)','khaki': 'rgb(126, 128, 93)','southampton': 'rgb(101, 165, 231)','cherry': 'rgb(210, 4, 45)','stone': 'rgb(214, 180, 135)','mustard': 'rgb(225, 173, 1)','original': 'rgb(244, 194, 194)','beige': 'rgb(234, 216, 171)','morkgra': 'rgb(148, 149, 152)','mint': 'rgb(171, 222, 203)','petrol': 'rgb(99, 187, 212)','korall': 'rgb(248, 131, 121)','tutu': 'rgb(255, 223, 196)','ethernal': 'rgb(86, 255, 190)','ljusgra': 'rgb(211, 211, 211)','frost': 'rgb(245, 245, 245)','ljusrosa': 'rgb(254, 221, 193)','brun': 'rgb(205, 127, 50)','bitten': 'rgb(89, 25, 31)','champagne': 'rgb(255, 138, 158)','elle': 'rgb(249, 149, 132)','doe': 'rgb(226, 202, 182)','oat': 'rgb(216, 194, 157)','gron': 'rgb(5, 170, 61)','bla': 'rgb(0, 91, 211)','terracotta': 'rgb(186, 107, 107)','pistachio': 'rgb(147, 197, 114)','vit': 'rgb(255, 255, 255)','natur': 'rgb(252, 246, 217)','silver': 'rgb(211, 211, 211)','ljusbla': 'rgb(173, 216, 230)','ljusgron': 'rgb(125, 224, 128)','denim': 'rgb(77, 113, 163)','denim': 'rgb(132, 160, 187)','blue': 'rgb(0, 91, 211)','rosa': 'rgb(255, 192, 203)','gul': 'rgb(255, 229, 0)','gra': 'rgb(128, 128, 128)','bla': 'rgb(77, 113, 163)','sage': 'rgb(157, 192, 168)','wine': 'rgb(154, 86, 48)',};

    this.images = {'sea-breeze': 'url("//joiliving.com/cdn/shop/files/Sea-breeze_120x.png?v=5454550777700629489")','vit-bla': 'url("//joiliving.com/cdn/shop/files/vitbla_120x.png?v=14600526614014662257")','gul-rosa': 'url("//joiliving.com/cdn/shop/files/gulrosa_120x.png?v=15919594344117225789")','farg1': 'url("//joiliving.com/cdn/shop/files/farg1_120x.png?v=10211005078204987307")','regnbage': 'url("//joiliving.com/cdn/shop/files/regnbage_120x.png?v=4356658425478154176")','melange': 'url("//joiliving.com/cdn/shop/files/melange_120x.png?v=17824886216342455103")','farg2': 'url("//joiliving.com/cdn/shop/files/farg2_120x.png?v=13167910162826919089")','klassisk1': 'url("//joiliving.com/cdn/shop/files/klassisk1_120x.png?v=2285916123806337629")','klassiskorange': 'url("//joiliving.com/cdn/shop/files/klassiskorange_120x.png?v=4481028088136429421")','farg3': 'url("//joiliving.com/cdn/shop/files/farg3_120x.png?v=5855788858986437916")','supernova': 'url("//joiliving.com/cdn/shop/files/Supernova_120x.png?v=6374198990994754813")','ocean': 'url("//joiliving.com/cdn/shop/files/Ocean_120x.png?v=2797589798448575543")','blue-blast': 'url("//joiliving.com/cdn/shop/files/Blue-blast_120x.png?v=4700474816242612807")','alternativ-farg-1': 'url("//joiliving.com/cdn/shop/files/Alternativ_120x.png?v=17328484514920932535")','alternativ-farg-2': 'url("//joiliving.com/cdn/shop/files/Alternativ_farg-2_120x.png?v=5390879897889989942")','purple-blast': 'url("//joiliving.com/cdn/shop/files/Purple-blast_120x.png?v=3858408631710953035")',};

    this.triggers = ['color','colour','couleur','farbe','cor','färg',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
